import { IdentifierDTO } from '@zazume/zzm-base';

import { ServiceType } from '#/domain/ownerServiceContract/types';

export const OwnerServiceContractKeys = {
  base: ['ownerServiceContract'],
  byId: (ownerServiceContractId: IdentifierDTO) => [...OwnerServiceContractKeys.base, ownerServiceContractId],
  byUnitId: (unitId: IdentifierDTO) => [...OwnerServiceContractKeys.base, 'unit', unitId],
  findLastByUnitIdAndServiceType: (unitId: IdentifierDTO, serviceType: ServiceType) => [
    ...OwnerServiceContractKeys.base,
    'unit',
    unitId,
    serviceType,
    'last'
  ],
  currentManagementByUnitId: (unitId: IdentifierDTO) => [
    ...OwnerServiceContractKeys.base,
    'unit',
    unitId,
    'Management',
    'current'
  ],
  findOneBlockerToCreationByUnitId: (unitId: IdentifierDTO, serviceType: ServiceType) => [
    ...OwnerServiceContractKeys.base,
    'unit',
    unitId,
    serviceType,
    'blocker-to-creation'
  ],
  terminatedByUnitIdAndServiceType: (unitId: IdentifierDTO, serviceType: ServiceType) => [
    ...OwnerServiceContractKeys.base,
    'unit',
    'terminated',
    unitId,
    serviceType
  ],
  rentAdvanceProgressIncomes: (ownerServiceContractId: IdentifierDTO) => [
    ...OwnerServiceContractKeys.base,
    'renta-advance-incomes',
    ownerServiceContractId
  ],
  findAllActiveByOwnerAccountId: (ownerAccountId: IdentifierDTO) => [
    ...OwnerServiceContractKeys.base,
    'active',
    'ownerAccount',
    ownerAccountId
  ],
  rentAdvanceNotPaidByUnitId: (unitId: IdentifierDTO) => [
    ...OwnerServiceContractKeys.base,
    'rent-advance',
    'not-paid',
    'unit',
    unitId
  ]
};
